import React, { useState, useEffect } from 'react';
import { Eye, Users, Heart, TrendingUp, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API = `${window.location.origin}/api`;

export default function BookViewMetrics({ bookId }) {
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    if (!bookId) return;
    const fetchMetrics = async () => {
      try {
        const res = await axios.get(`${API}/book-metrics/${bookId}`);
        setMetrics(res.data);
      } catch {
        // Silent fail
      }
    };
    fetchMetrics();
  }, [bookId]);

  if (!metrics) return null;

  const items = [
    { icon: Eye, label: 'Views', value: metrics.total_views, color: '#3B82F6' },
    { icon: Heart, label: 'Engagement', value: `${metrics.avg_engagement_score}%`, color: '#EF4444' },
    { icon: TrendingUp, label: 'Completion', value: `${metrics.completion_rate}%`, color: '#F59E0B' },
  ];

  return (
    <div data-testid="book-view-metrics" className="flex flex-wrap gap-3 py-2">
      {items.map((item, i) => (
        <div
          key={i}
          className="flex items-center gap-1.5 px-2 py-1 bg-zinc-900/60 rounded-md border border-zinc-800"
        >
          <item.icon className="w-3 h-3" style={{ color: item.color }} />
          <span className="text-[11px] text-zinc-400">{item.label}</span>
          <span className="text-[11px] font-semibold text-white">{item.value}</span>
        </div>
      ))}
      {metrics.daily_view_growth !== 0 && (
        <div className={`flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-medium ${
          metrics.daily_view_growth > 0 ? 'bg-green-500/10 text-green-400' : 'bg-red-500/10 text-red-400'
        }`}>
          <TrendingUp className="w-3 h-3" />
          {metrics.daily_view_growth > 0 ? '+' : ''}{metrics.daily_view_growth}% today
        </div>
      )}
    </div>
  );
}
